module.exports = __webpack_public_path__ + "img/26-small.b3390883.png";